// Action Types
const prefix = '@@hotkey_template/';

export const HOTKEY_TMP_RESET = `${prefix}HOTKEY_TMP_RESET`;
export const HOTKEY_TMP_SELECT_HOTKEY = `${prefix}SELECT_HOTKEY`;
export const HOTKEY_TMP_EDIT_HOTKEY = `${prefix}EDIT_HOTKEY`;
export const HOTKEY_TMP_SAVE_HOTKEY_TEMPLATE = `${prefix}SAVE_HOTKEY_TEMPLATE`;
export const HOTKEY_TMP_EDIT_HOTKEY_TEMPLATE = `${prefix}EDIT_HOTKEY_TEMPLATE`;
export const HOTKEY_TMP_DELETE_HOTKEY_TEMPLATE = `${prefix}DELETE_HOTKEY_TEMPLATE`;
export const HOTKEY_TMP_ADD_NEW_TAB = `${prefix}ADD_NEW_TAB`;
export const HOTKEY_TMP_ADD_NEW_CHILD = `${prefix}ADD_NEW_CHILD`;
export const HOTKEY_TMP_EDIT_TAB = `${prefix}EDIT_TAB`;
export const HOTKEY_TMP_EDIT_CHILD = `${prefix}EDIT_CHILD`;
export const HOTKEY_TMP_DELETE_TAB = `${prefix}DELETE_TAB`;
export const HOTKEY_TMP_DELETE_CHILD = `${prefix}DELETE_CHILD`;
export const HOTKEY_TMP_MOVE_TAB = `${prefix}MOVE_TAB`;
export const HOTKEY_TMP_MOVE_CHILD = `${prefix}MOVE_CHILD`;
export const HOTKEY_TMP_SET_LEVEL = `${prefix}SET_LEVEL`;
export const HOTKEY_TMP_SET_TABS = `${prefix}SET_TABS`;
export const HOTKEY_TMP_RESET_LEVEL_SAVE = `${prefix}RESET_LEVEL_SAVE`;
export const HOTKEY_TMP_MARK_LEVEL_SAVE = `${prefix}MARK_LEVEL_SAVE`;
export const HOTKEY_TMP_SELECT_TAB = `${prefix}SELECT_TAB`;
export const HOTKEY_TMP_SET_SELECTED_TAB = `${prefix}SET_SELECTED_TAB`;
export const HOTKEY_TMP_SET_CHILDREN = `${prefix}SET_CHILDREN`;
export const HOTKEY_TMP_GET_CHILDREN = `${prefix}GET_CHILDREN`;
export const HOTKEY_TMP_TOGGLE_TAB_ACTIVE = `${prefix}TOGGLE_TAB_ACTIVE`;
export const HOTKEY_TMP_TOGGLE_CHILD_ACTIVE = `${prefix}TOGGLE_CHILD_ACTIVE`;
export const HOTKEY_TMP_SET_TEMPLATE_STATE = `${prefix}SET_TEMPLATE_STATE`;
export const HOTKEY_TMP_SHOW_ADD_MODAL = `${prefix}SHOW_ADD_MODAL`;
export const HOTKEY_TMP_RESET_ADD_MODAL = `${prefix}RESET_ADD_MODAL`;
export const HOTKEY_TMP_RESET_EDIT_MODAL = `${prefix}RESET_EDIT_MODAL`;
export const HOTKEY_TMP_SET_FETCHING_STATUS = `${prefix}SET_FETCHING_STATUS`;
export const HOTKEY_TMP_SET_SUBMITTING_STATUS = `${prefix}SET_SUBMITTING_STATUS`;
export const HOTKEY_TMP_SET_ERROR_STATUS = `${prefix}SET_ERROR_STATUS`;


// Document Types
export const DOC_TYPE_ITEM = 'item';
export const DOC_TYPE_HOTKEY_GROUP = 'hotkey_group';
export const DOC_TYPE_HOTKEY_GROUP_ITEM = 'hotkey_group_item'; 
export const DOC_TYPE_HOTKEY_TEMPLATE = 'hotkey_template';
export const DOC_TYPE_HOTKEY_TEMPLATE_GROUP = 'hotkey_template_group';


// Add Document
export const ADD_DOC_ID = 'dt:hotkey_tmp:add';
export const ADD_DOC= { id: ADD_DOC_ID };


// Modal Constants
export const MODAL_MODE_ADD_TAB = 'MODAL_MODE_ADD_TAB';
export const MODAL_MODE_ADD_CHILD = 'MODAL_MODE_ADD_CHILD';
export const MODAL_MODE_EDIT_TAB = 'MODAL_MODE_EDIT_TAB';
export const MODAL_MODE_EDIT_CHILD = 'MODAL_MODE_EDIT_CHILD';


// Form Constants
export const FORM_ID_TEMPLATE = 'HotkeyTemplate';
export const FORM_ID_ADD_MODAL = 'HotkeyTemplateAddModal';
export const FORM_ID_EDIT_MODAL = 'HotkeyTemplateEditModal';
export const FORM_ADD_TYPE_GROUP = 'dt:add_type:group';
export const FORM_ADD_TYPE_ITEM = 'dt:add_type:item';
export const FORM_GROUP_TYPE_CLASS = 'dt:hotkey_type:class';
export const FORM_GROUP_TYPE_ITEM = 'dt:hotkey_type:item';


// Select Constants
export const SELECT_MODE_TAB = 'dt:select:tab';
export const SELECT_MODE_CHILD = 'dt:select:child';
export const SELECT_MODE_BREADCRUMB = 'dt:select:breadcrumb';
